import React, { Component } from 'react';
import { Content } from 'rsuite';
import history from '../../history';
import { DASHBOARD } from '../../../constants/permissions/inventory';
import { viewAccess } from '../../../helpers/permission';
import AccessControl from '../../../components/AccessControl';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import { inventoryItemsPath } from '../../Paths';

class InventoryDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    history.push(inventoryItemsPath);
  }

  render() {
    return (
      <InventoryPageLayout>
        <PageHeader title="Dashboard" />
        <Content>
          <AccessControl
            allowWhenAny={[viewAccess(DASHBOARD)]}
            fallback="Permission Deneid"
          >
            Dashboard content
          </AccessControl>
        </Content>
      </InventoryPageLayout>
    );
  }
}

InventoryDashboard.propTypes = {
  // onInit: PropTypes.func.isRequired
  // onSubmit: PropTypes.func.isRequired
};

export default InventoryDashboard;
